const ORGANIZATION_MASTER = {
  DIMENSA: 'dimensa',
}

export {
  ORGANIZATION_MASTER,
}
